// layoutUtils.js
import { ref } from 'vue'
import { BLINK_FIELD_CONSTANTS } from '@src/constants/layout-constant'
import DEFAULT_LAYOUT_DATA from '@/src/router/layouts/defaultLayout.json'
import store from '@src/state/store'
import { SCOPE_LEVELS } from '@src/constants/general-constants.js'
const blinkRegistry = new Map()

function ensureEntry(key) {
  if (!blinkRegistry.has(key)) {
    blinkRegistry.set(key, { flag: ref(false), intervalId: null })
  }
  return blinkRegistry.get(key)
}

export const leftBarHiddenForCurrentRoute = (routeName) => {
  return DEFAULT_LAYOUT_DATA.leftBarHiddenFor.includes(routeName)
}

export const useBlinkField = (key) => {
  const entry = ensureEntry(key)

  const startBlink = () => {
    entry.flag.value = true
    let count = 0
    clearInterval(entry.intervalId)
    entry.intervalId = setInterval(() => {
      entry.flag.value = !entry.flag.value
      count++
      if (count >= BLINK_FIELD_CONSTANTS.MAX_BLINKS * 2) {
        clearInterval(entry.intervalId)
        entry.flag.value = false
      }
    }, BLINK_FIELD_CONSTANTS.BLINK_INTERVAL)
  }

  const stopBlink = () => {
    clearInterval(entry.intervalId)
    entry.flag.value = false
  }

  const getBlink = () => entry.flag.value

  return { startBlink, stopBlink, getBlink }
}

export const startBlinkMany = (keys = []) => {
  keys.forEach((key) => useBlinkField(key).startBlink())
}

export const stopBlinkMany = (keys = []) => {
  keys.forEach((key) => useBlinkField(key).stopBlink())
}
export const BLINK_KEYS = Object.freeze({
  CAMPUS: 'campus',
  CLASS: 'class',
  SECTION: 'section',
  NO_RECORD: 'noRecordFound',
})

export const checkScopeLevelByBasedOn = (basedOn = []) => {
  let currentCampusScope = store.state.layout.currentCampusScope
  let currentSectionScope = store.state.layout.currentSectionScope
  let currentClassScope = store.state.layout.currentClassScope
  switch (true) {
    case !basedOn.length || basedOn.includes(SCOPE_LEVELS.ROOT_LEVEL):
      return true
    case basedOn.includes(SCOPE_LEVELS.CAMPUS_LEVEL):
      return !!currentCampusScope
    case basedOn.includes(SCOPE_LEVELS.CLASS_LEVEL):
      return !!currentClassScope
    case basedOn.includes(SCOPE_LEVELS.SECTION_LEVEL):
      return !!currentSectionScope
    default:
      return false
  }
}
export const getLevelVisibility = (level = []) => {
  const defaults = { isCampusLevel: true, isClassLevel: true, isSectionLevel: true }
  if (!level.length) return defaults
  switch (true) {
    case level.includes(SCOPE_LEVELS.SECTION_LEVEL):
      return { isCampusLevel: true, isClassLevel: true, isSectionLevel: true }

    case level.includes(SCOPE_LEVELS.CLASS_LEVEL):
      return { isCampusLevel: true, isClassLevel: true, isSectionLevel: false }

    case level.includes(SCOPE_LEVELS.CAMPUS_LEVEL):
      return { isCampusLevel: true, isClassLevel: false, isSectionLevel: false }

    case level.includes(SCOPE_LEVELS.ROOT_LEVEL):
      return { isCampusLevel: false, isClassLevel: false, isSectionLevel: false }

    default:
      return defaults
  }
}
